<script lang="ts" setup>
import {
  Co2QuizAnswer,
  Co2QuizQuestion,
  QuestionType,
} from '@/models/co2-quiz.model';
import { SimpleUserCo2QuizAnswer } from '@/models/user.model';
import { PropType, ref } from 'vue';

const props = defineProps({
  question: {
    type: Object as PropType<Co2QuizQuestion>,
    required: true,
  },
  selected: {
    type: Object as PropType<SimpleUserCo2QuizAnswer | null>,
    required: true,
  },
  followups: {
    type: Object as PropType<number[]>,
    required: true,
  },
});

const inputValue = ref<string>(
  props.selected?.inputValue ? `${props.selected?.inputValue}` : '',
);

const selectedAnswer = ref<Co2QuizAnswer | null>(null);

const emit = defineEmits(['update:answer']);

function selectAnswer(answer: Co2QuizAnswer | null, inputValue?: string) {
  selectedAnswer.value = answer;
  emit('update:answer', { answer, inputValue });
}
</script>
<template>
  <v-card class="mb-4">
    <v-card-text>
      <h4>
        {{ question.title }}
        <span class="type">
          {{
            question.partQuestion
              ? 'Part'
              : question.parentQuestion
              ? 'Sub'
              : followups.includes(question.id)
              ? 'Follow-up'
              : 'Main'
          }}</span
        >
      </h4>
    </v-card-text>
    <v-card-text>
      <div class="answer-options">
        <div
          class="answer-option"
          v-for="answer in [...question.answers].sort(
            (a, b) => a.index - b.index,
          )"
          :key="answer.id"
        >
          <v-btn
            :color="selected?.answer?.id === answer.id ? 'info' : ''"
            density="compact"
            block
            class="mb-1"
            @click="selectAnswer(answer)"
            >{{ answer.text.replace(/\s\(.+\)/g, '') }}</v-btn
          >
        </div>
      </div>
      <div
        class="answer-options"
        v-if="
          question.questionType === QuestionType.UserInput ||
          selectedAnswer?.isOther
        "
      >
        <v-text-field
          v-model="inputValue"
          label="Input"
          density="compact"
          hide-details="auto"
        ></v-text-field>
        <v-btn
          class="ml-4"
          color="info"
          @click="selectAnswer(selectedAnswer, inputValue)"
          >Update</v-btn
        >
      </div>
    </v-card-text>
  </v-card>
</template>
<style scoped>
h4 {
  position: relative;
}
.type {
  position: absolute;
  top: 0;
  right: 0;
}
.answer-options {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.answer-option {
  width: 50%;
}
</style>
